<template>
  <section class="services">
    <div v-if="servicesAll"
      class="services__container">
      <app-title class="services__title">
        {{ title }}
      </app-title>
      <ServicesList :services-list="servicesList" />
    </div>
    <div v-else
      class="services__container">
      <div class="services__left">
        <app-title class="services__title">
          К Вашим услугам
        </app-title>
        <div v-clamp="9"
          class="services__description">
          {{ description }}
        </div>
        <div class="services__link">
          <app-button to="/services">
            Все услуги
          </app-button>
        </div>
      </div>
      <div class="services__right">
        <template v-if="isMobile">
          <swiper 
            class="services-swiper__swiper"
            :modules="modules"
            :breakpoints="{
              320: { slidesPerView: 2 },
              640: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
              1280: { slidesPerView: 4 },
            }"
            :space-between="8"
            :speed="800"
            :navigation="{ nextEl: '.services-swiper__nav_next', prevEl: '.services-swiper__nav_prev' }"
          >
            <swiper-slide 
              v-for="(service, index) in servicesList"
              :key="index"
              class="services-swiper__slide"
            >
              <ServicesCard :service="service" />
            </swiper-slide>
          </swiper>

          <div class="services-swiper__nav-swiper">
            <div class="services-swiper__nav_prev">
              <app-svg id="arrow-left"
                width="15"
                height="15" />
            </div>
            <div class="services-swiper__nav_next">
              <app-svg id="arrow-right"
                width="15"
                height="15" />
            </div>
          </div>
        </template>
        <ul v-else class="services__list">
          <li v-for="service in servicesList"
            :key="service.id"
            class="services__list-item">
            <ServicesCard :service="service" />
          </li>

          <li class="services__list-item">
            <ServicesCard :service="{
              title: 'Cделка под защитой',
              alias: 'clientsafe',
              lid_text: 'Вы получаете не только качественную услугу, но и финансовую защиту на&nbsp;20&nbsp;000&nbsp;000&nbsp;₽'
            }" nolink />
          </li>

        </ul>
      </div>
    </div>
  </section>
</template>

<script>
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";
import AppButton from "@/components/ui/AppButton.vue";
import ServicesCard from "@/components/ServicesCard.vue";
import ServicesList from "@/components/ServicesList.vue";

export default {
  name: "ServicesSection",
  components: {
    AppButton,
    ServicesCard,
    ServicesList,
    Swiper,
    SwiperSlide,
  },

  props: {
    servicesAll: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      description: null,
      servicesList: [],
      isMobile: false,
      modules: [Navigation],
    };
  },

  mounted() {
    this.getSevices();
    this.matchMedia();
  },

  methods: {
    getSevices() {
      this.axios
        .get("/api/services", {
          params: {
            limit: this.servicesAll ? "" : 7,
          },
        })
        .then(({ data }) => {
          this.description = data.description;
          this.servicesList = data.data;
        });
    },
    matchMedia() {
      const mediaQuery = window.matchMedia("(max-width: 639px)");

      if (mediaQuery.matches) {
        this.isMobile = true;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.services {
  $this: &;

  padding: 64px 0px;

  @include tablet {
    padding: 50px 0;
  }

  &__container {
    @extend %container;
    position: relative;
    display: flex;
    gap: 72px;

    @include laptop {
      min-width: 0;
      // flex-direction: column;
      display: block;
    }

    @include phone {
      // padding: 0;
    }
  }

  &__left {
    min-width: 280px;
    display: flex;
    flex-direction: column;

    @include phone {
      min-width: auto;
      margin-bottom: 30px;
    }
  }

  &__right {
    display: flex;
    align-items: flex-end;

    @include phone {
      min-width: 0;
      display: block;
    }
  }

  &__title {
    max-width: 280px;
    font-size: 65px;

    @include phone {
      margin-bottom: 30px;
    }
  }

  &__description {
    font-weight: 400;
    font-size: 18px;
    line-height: 26px;

    max-width: 300px;

    @include phone {
      font-size: 16px;
      line-height: 120%;
    }
  }

  &__list {
    display: grid;
    grid-template: 1fr / repeat(4, 1fr);
    grid-gap: 32px;

    @include media($max-width: 1920px) {
      grid-gap: calc(32 / 1920 * 100vw);
    }

    @include laptop {
      grid-template-columns: repeat(3, 1fr);
      grid-gap: 20px;
      margin-bottom: 30px;
    }

    @include tablet {
      grid-template-columns: repeat(2, 1fr);
      grid-gap: calc(20 / 1023 * 100vw);
    }

    @include phone {
      display: block;
    }
  }

  // &__list-item {
  //   &:first-child {
  //     @include laptop {
  //       grid-row: 1 / 3;
  //     }

  //     @include tablet {
  //       grid-row: auto;
  //     }

  //     @include phone {
  //       margin-bottom: 20px;
  //     }
  //   }
  // }

  &__link {
    @include flex-center;
    margin-top: auto;

    &>* {
      padding: 16px 60px;

      @include phone {
        height: 32px;
        padding: 8px 20px;
      }
    }

    @include phone {
      position: absolute;
      left: 50%;
      bottom: 0;
      transform: translateX(-50%);
    }
  }

  &-swiper__nav-swiper {
    display: flex;
    justify-content: center;
    margin-top: 60px;
    flex: none;
    display: flex;
    gap: 10px;
    color: $color_primary;

    .services-swiper__nav_prev,
    .services-swiper__nav_next {
      cursor: pointer;
      width: 46px;
      height: 46px;
      border-radius: 50%;
      border: 1px solid $color_orange-50;
      display: flex;
      align-items: center;
      justify-content: center;

      &.swiper-button-disabled {
        color: $color_grey-15;
        border-color: $color_grey-15;
      }

      flex: none;
      transition: color 0.3s ease,
      border 0.3s ease;

      @include phone {
        width: 32px;
        height: 32px;

        svg {
          width: 12px;
          height: 12px;
        }
      }
    }

    @include tablet {
      // display: none;
      justify-content: space-between;
      margin-top: 28px;
    }
  }
}
</style>
